// The Briefing while items are SELECTED (frame 40006905:278220).
//
//   🌐  Web search
//   Selected
//   🖼  3 photos
//   💬  2 snippets
//
// Same strip, same place as the search briefing — it simply takes over the moment anything is
// ticked, because at that point what matters is no longer what the search found but what you have
// kept. That is why it outranks `search` in the store.
//
// The counting itself is lib/researchBriefing.js, which predates the strip and is shared with the
// pack view. This module only dresses those counts as a briefing.

import { briefing } from './rows'
import { briefingTitle, briefingCounts } from '@/lib/researchBriefing'

// Which glyph each kind gets, from the frame: a picture for photos, a speech bubble for the
// answer snippets, the globe for links (the same globe the search briefing uses for a source).
// A video wears the picture glyph the rail gives one; a product the globe the pack
// briefing gives its products.
const ICONS = { photo: 'gallery', snippet: 'message-text', link: 'global', video: 'gallery', product: 'global' }

/**
 * @param query the search the selection came out of — no longer written into the heading
 *        (busy-my-web#218: a full query is a paragraph, not a title), kept on the signature
 *        because it is what this briefing is ABOUT and the caller already holds it
 * @param items the workboard's items
 * @returns a briefing, or null when nothing is selected
 */
export function selectionBriefing(query, items) {
  const rows = briefingCounts(items || [])
  if (!rows.length) return null

  return briefing({
    kind: 'selection',
    title: briefingTitle(),
    titleIcon: 'global',
    // The frame puts a bold "Selected" between the title and the counts — it is what the numbers
    // are ABOUT, and without it "3 photos" could as easily mean "3 photos found".
    subtitle: 'Selected',
    rows: rows.map(r => ({ key: r.key, icon: ICONS[r.key], text: r.label })),
  })
}
